import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav, Container, Button } from "react-bootstrap";

const MyNavbar = () => {
  const [logoError, setLogoError] = useState(false);

  return (
    <Navbar
      bg="white"
      variant="light"
      expand="md"
      fixed="top"
      className="top-navbar shadow-sm"
    >
      <Container className="nav-container">
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center brand-wrap">
          {!logoError ? (
            <img
              src="/images/sparklogic-logo-badge.svg"
              alt="SPARK LOGIC"
              className="brand-logo"
              onError={() => setLogoError(true)}
            />
          ) : (
            <span className="brand-text">
              SPARK<span className="brand-accent">LOGIC</span>
            </span>
          )}
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" className="nav-toggle" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center nav-links">
            <Nav.Link as={Link} to="/" className="nav-item">Home</Nav.Link>
            <Nav.Link as={Link} to="/about" className="nav-item">About</Nav.Link>
            <Nav.Link as={Link} to="/services" className="nav-item">Services</Nav.Link>
            <Nav.Link as={Link} to="/pricing" className="nav-item">Pricing</Nav.Link>
            <Nav.Link as={Link} to="/how-it-works" className="nav-item">How It Works</Nav.Link>
            <Nav.Link as={Link} to="/register" className="nav-item">Register Here</Nav.Link>

            <Nav.Link as={Link} to="/contact" className="ms-lg-2">
              <Button className="nav-cta">Contact</Button>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default MyNavbar;